import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Field, withFormik } from "formik";
import isEmpty from "lodash/isEmpty";

import i18n from "../../../../translations/i18n";
import {
  USER_RESTORE_PASSWORD_SHAPE,
  USER_AUTH_SHAPE
} from "../../../../constants/userConstants";

import FormGroup from "../../../../components/ui/form/group";
import FormActions from "../../../../components/ui/form/actions";
import FormError from "../../../../components/ui/form/error";
import InputField from "../../../../components/ui/form/input_field";
import Button from "../../../../components/ui/form/button";


class RestorePasswordForm extends Component {

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    const { auth, setSubmitting } = this.props;

    if (prevProps.auth !== auth && auth.error) {
      setSubmitting(false);
    }
  }

  render() {
    const {
      auth,
      touched,
      isSubmitting,
      handleSubmit,
    } = this.props;

    return(
      <Form>
        <div className="modal__form-fields-group">
          <FormGroup label={i18n.t("pages.restore_password.form.email.label")} touched={touched.email}>
            <Field
              component={InputField}
              name="email"
              required
            />
          </FormGroup>
        </div>

        <FormActions className="modal__form-button-wrapper">
          <FormError>
            {auth.error}
          </FormError>
          <Button
            className="modal__form-button"
            type="submit"
            disabled={isSubmitting}
            onSubmit={handleSubmit}
          >
            {i18n.t("pages.restore_password.form.submit.title")}
          </Button>
        </FormActions>
      </Form>
    )
  }
}

const RestorePasswordFormWithFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({initialValues}) => initialValues,
  handleSubmit: (values, {props: {onSubmit}}) => onSubmit(values),
  validate: (values) => {
    let errors = {};

    if (isEmpty(values.email)) {
      errors.email = i18n.t("validation.field.required");
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
      errors.email = i18n.t("validation.email.invalid");
    }

    return errors;
  },
})(RestorePasswordForm);

RestorePasswordFormWithFormik.propTypes = {
  initialValues: PropTypes.shape(USER_RESTORE_PASSWORD_SHAPE).isRequired,
  auth: PropTypes.shape(USER_AUTH_SHAPE).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default RestorePasswordFormWithFormik
